import React, { Component } from 'react';
import axios from 'axios';
import YouTube from 'react-youtube';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ResponsiveEmbed from 'react-responsive-embed';
import { BsCameraVideo } from 'react-icons/bs';

class MainScreen extends Component {

    constructor(props) {
        super(props)

        this.state = {
            wordPressSiteUrl: 'https://ateret.activebranding.co.il',
            Categories: [],
            Tags: [],
            Lessons: [],
            backsrc: '/wp-content/plugins/hello-world-react/media/wallBackground.jpg',
            loading: false
        }
    }
    componentDidMount() {
        this.GetCategories()
        this.GetTags()
        this.GetRecentLessons()
    }


    GetCategories = () => {
        const wordPressSiteUrl = this.state.wordPressSiteUrl
        const ApiLink = `${wordPressSiteUrl}/wp-json/wp/v2/categories`
        axios.get(ApiLink)
            .then(res => {
                console.log(res.data)
                this.setState({
                    Categories: res.data
                })

            })
            .catch(err => {
            })
    }
    GetTags = () => {
        const wordPressSiteUrl = this.state.wordPressSiteUrl
        const ApiLink = `${wordPressSiteUrl}/wp-json/wp/v2/tags`
        axios.get(ApiLink)
            .then(res => {
                console.log(res.data)
                this.setState({
                    Tags: res.data
                })

            })
            .catch(err => {
            })
    }
    GetRecentLessons = () => {
        const wordPressSiteUrl = this.state.wordPressSiteUrl
        const PageId = 190
        const ApiLink = `${wordPressSiteUrl}/wp-json/wp/v2/pages/${PageId}`
        this.setState({
            loading:true
        })
        axios.get(ApiLink)
            .then(res => {
                console.log(res.data.acf.lessons)
                this.setState({
                    Lessons: res.data.acf.lessons,
                    loading:false
                })
            })
            .catch(err => {
                console.log(err)
            })
    }

    testpost = () => {
        const wordPressSiteUrl = 'https://ateret.activebranding.co.il'
        const ApiLink = `${wordPressSiteUrl}/wp-json/wl/v1/get_page_content`
        // const ApiLink = `${wordPressSiteUrl}/wp-json/wp/v2/pages?parent=${PageId}`

        let formData = new FormData();
        formData.append('name', 'guy');

        axios.post(ApiLink, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(res => {
                console.log(res.data)

            })
            .catch(err => {

            })
    }

    testget = () => {
        const wordPressSiteUrl = 'https://ateret.activebranding.co.il'
        // const ApiLink = `${wordPressSiteUrl}/wp-json/wl/v1/get_page_content`
        const PageId = 140
        const ApiLink = `${wordPressSiteUrl}/wp-json/wp/v2/pages?parent=${PageId}`

        axios.get(ApiLink)
            .then(res => {
                console.log(res.data)
                console.log(this.state.Categories)
            })
            .catch(err => {
                console.log(err)
            })
    }

    render() {
        let Items = []
        this.state.Lessons.map((item, index) => {
            console.log(item.youtubeid)
            Items.push(
                <div className='carousel-item'>
                    <ResponsiveEmbed
                        src={'https://www.youtube.com/embed/' + item.youtubeid}
                        allowfullscreen="allowfullscreen" />
                    <div className='video_title_container'>
                        <h4 className='video_title'>{item.title}</h4>
                        <div className='lesson_number_container'>
                            <div className='lesson_number'>{item.lesson_number}</div>
                        </div>
                    </div>

                </div>
            )
        })



        const responsive = {
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 3,
                slidesToSlide: 3 // optional, default to 1.
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 2,
                slidesToSlide: 2 // optional, default to 1.
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1,
                slidesToSlide: 1 // optional, default to 1.
            }
        };



        return (

            <div className='last_video_container'>
                <BsCameraVideo className="icon" size={30} />
                <div className='title'>שיעורים שהועלו לאחרונה</div>
                {this.state.loading ?
              <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                    :
                    <Carousel
                        infinite={true}
                        responsive={responsive}
                        autoPlay={false}
                        containerClass="carousel-container"
                        // removeArrowOnDeviceType={["mobile"]}
                        swipeable={true}
                        shouldResetAutoplay={false}
                        itemClass="carouselItem"
                    // infinite={true}
                    // showDots={true}
                    >

                        {Items}
                    </Carousel>
                }
                <h2 className='view_all_lessons'>לצפייה בכל השיעורים<br />מבית המדרש</h2>
                <a href='https://ateret.activebranding.co.il/%d7%a9%d7%99%d7%a2%d7%95%d7%a8%d7%99%d7%9d-%d7%9e%d7%91%d7%99%d7%aa-%d7%94%d7%9e%d7%93%d7%a8%d7%a9/' className='goto'>{'<<<'}</a>
                <div className='last_video_container_back'><img src={this.state.wordPressSiteUrl + this.state.backsrc} /></div>
            </div>


        );


    }
}
export default MainScreen;

